export default {
    ambassadorBtn_title: "Sorteo de tarjetas regalo",
    ambassadorBtn_subtitle: "Reviews = Rewards",
    ambassadorPopup_title: "PARTICIPAR EN EL SORTEO DE UNA TARJETA REGALO",
    ambassadorPopup_votes: '20 AirVotes',
    giveawayPopup_login: "Conéctate a Google o Facebook",
    ambassadorPopup_review: "Deja una reseña en cualquiera de las páginas de {v1}",
    giveawayPopup_entered: "Participarás en",
    ambassadorPopup_BtnLogin: "Empieza por conectarte",
    giveawayPopup_BtnReview: "Deja una reseña en cualquiera de las páginas de {v1}.",
    ambassadorPopup_cancel: "No quiero participar",
    ambassadorFinishTitle: "Te agradecemos tu sincera reseña. Has sido añadido a nuestro sorteo. Vuelve a votar: ¡cada voto aumentará tus posibilidades!",
    ambassadorMonthlyDrawing: "Every AirVote enters you into a monthly $100 drawing",
    ambassadorReceive: "Ambassadors will receive extra goodies and recognition!",
    ambassadorHelpUsTogether: "Help us succeed together!",
    giveawayPopup_proceedReview: "Proceda a enviar una reseña",
    Thank_for_vote: "Gracias por su voto. ¿Quieres seguir tus votos? Inicia sesión con",
    thankVoteTitle1: "Comentarios guardados",
    thankVoteTitle2_1: "Gracias por votar",
    thankVoteTitle2_2: "Únete a AirVote para poder revisar y cambiar tus votos",
    writeFeedBack: "Añade una nota (opcional)",
    voteSuccessText_1: "Voto enviado, ¡gracias!",
    voteSuccessText_2: "¿Quieres cambiarlo? Toca otro smiley.",
    voteSuccessText_3: "¿Tienes algo que decir? Deja una nota opcional",
    feedbackTitle: "Añade una nota",
    feedbackTitleSoSo: "¿Qué podría ser mejor?",
    feedbackTitleSad: "¿Qué no está bien?",
    feedbackTextRating: '¿Por qué le has dado esta puntuación a este altavoz?',
    writeAReview: "Escribir una reseña",
    writeAReviewTitle: "Puedes escribir una opinión sobre {v1} aquí:",
    yourNote: "Su nota",
    addYourNote: "Agrega una nota ?",
    commentPopupEmail: "Introduzca su correo electrónico o teléfono",
    feedbackText: "Quiero que me respondan sobre esto",
    feedbackTextServiceLog: "Información de contacto del servicio",
    feedbackHelpText: "El propietario del sitio lo recibirá para ponerse en contacto con usted",
    title_404: "La página a la que intentas acceder no está disponible",
    Submit: "Envía tu comentario",
    Cancel: "Cancelar",
    Logout: "Cierre de sesión",
    Sync_status: "Sincronizar estado",
    reviewSocial: "Sobre nosotros",
    anonComment: "Añadir comentario anónimo",
    powered_by: "Powered by AirVote\nObténgalo para su negocio",
    QR_smiley_disabled: "Este QR Smiley® ha sido desactivado.\nPor favor, dirija sus comentarios directamente a la empresa.",
    QR_smiley_disabled_links: "¿Tiene alguna pregunta sobre AirVote®?\nConsulte {v1} o envíenos un correo electrónico a {v2}.",
    QR_smiley_disabled_footer: "Gracias por sus comentarios.",
    manageNotEnoughPermissions: "No tienes suficientes permisos para gestionar esta pregunta de AirVote. Por favor, inicie sesión con una cuenta diferente o solicite un permiso",
    welcomeAmbassador: "Welcome back, J Bar Ambassador!",
    ambassadorDescription: "Every AirVote enters you into a monthly $100 drawing (limit 1 per location per day)\n" +
        "Ambassadors will receive extra goodies and recognition!\n" +
        "\n" + "Help us succeed together!",
    Placement: "Colocación",
    Update: "Actualizar",
    NewPlacementSaved: "Nueva ubicación guardar exitosa",
    PleaseEnterCorrectPlacement: "Ingrese la ubicación correcta",
    manageGPSAllowTitle: "¿Te importaría compartir tu ubicación?",
    manageGPSAllowText: "Conocer la ubicación exacta de un problema nos ayuda a solucionarlo más rápido. No rastrearemos su ubicación ni la compartiremos con nadie fuera de nuestro equipo de servicio.",
    manageGPSAllowOKButton: "OK para compartir",
    manageGPSAllowCancelButton: 'Prefiero no',
    level2_notp: "Sin Papel Higienico",
    level2_full: "Lleno",
    level2_dirty: "Sucio",
    level2_smells: "Huele mal",
    level2_broken: "Algo roto",
    level2_otherl: "Otros",
    level2_nopaper: "No hay toallas",
    level2_title: "Servicios desempeñados",
    level2_maxCount: "Número máximo de artículos a elegir: {v1}",
    need_audio_permission_error: "Por favor, danos acceso a tu micrófono para grabar el audio",
    vote_screen_public_review_popup_title: "Déjanos una reseña pública",
    sl_final_Title1: "Service log saved!",
    serviceLogInfoBtn: "Historial de servicio",
    snapPicturePopupTitle: "Confirma tu voto con la foto del baño",
    snapPictureButton: "Haz una foto",
    snapPicturePopupContinue: "Continue",
    subtitleDefault: "¡Se agradece tu imagen del problema!",
    signIn_Pin: "Sign in with PIN",
}
